type RouteKeys =
  | 'Login'
  | 'Home'
  | 'SimulationList'
  | 'SimulationTool'
  | 'SimulationNotFound'
  | 'CreatePrice'
  | 'CopyPrice'
  | 'PriceCalculator'
  | 'CalcSettings'
  | 'PriceLookup'
  | 'ResetNoveltyPrices'
  | 'Unauthorized'
  | 'DevDashboard';

type RouteObject = {
  path: string;
  staticPath: string;
};

export const MAIN_NAV_ITEMS = {
  PriceSetup: '/price-setup',
  PricePlanning: '/price-planning',
  Admin: '/admin',
};

export const ROUTES = {
  Login: {
    path: '/login',
    staticPath: '/login',
  },
  Home: {
    path: '/',
    staticPath: '/',
  },
  SimulationList: {
    path: '/price-planning/simulation-tool',
    staticPath: '/price-planning/simulation-tool',
  },
  SimulationTool: {
    path: '/price-planning/simulation-tool/:simulationId',
    staticPath: '/price-planning/simulation-tool',
  },
  SimulationNotFound: {
    path: '/price-planning/not-found',
    staticPath: '/price-planning/not-found',
  },
  CreatePrice: {
    path: '/price-planning/create-price',
    staticPath: '/price-planning/create-price',
  },
  CopyPrice: {
    path: '/price-planning/copy-price',
    staticPath: '/price-planning/copy-price',
  },
  PriceCalculator: {
    path: '/price-setup/price-calculator',
    staticPath: '/price-setup/price-calculator',
  },
  CalcSettings: {
    path: '/price-setup/calculation-settings',
    staticPath: '/price-setup/calculation-settings',
  },
  PriceLookup: {
    path: '/admin/find-price',
    staticPath: '/admin/find-price',
  },
  ResetNoveltyPrices: {
    path: '/admin/reset-novelty-prices',
    staticPath: '/admin/reset-novelty-prices',
  },
  Unauthorized: {
    path: '/unauthorized',
    staticPath: '/unauthorized',
  },
  // Internal developer dashboard. It is not in the navigation: only people who know the path use it.
  DevDashboard: {
    path: '/dev/dashboard',
    staticPath: '/dev/dashboard',
  },
} as Record<RouteKeys, RouteObject>;
